<template>
	<nk-wrapper v-if="user" spacing="md">
		<hr />
		<nk-text>
			<nk-button @click.prevent="logout">Abmelden</nk-button>
		</nk-text>
	</nk-wrapper>
</template>

<script>
import TemplatesDefault from '../../mixins/templates-default';

/**
 * @prop {object} options
 */

export default {
	name: 'NkTemplateRatsinfosystemLogout',

	mixins: [TemplatesDefault],

	computed: {
		user() {
			return this.$store.state.nuxtKommunen.ratsinfoauth.user;
		},
	},

	methods: {
		logout() {
			this.$store.dispatch('nuxtKommunen/ratsinfoauth/logout');
			this.$router.push(this.$route.path);
		},
	},
};
</script>
